/** Supported integration provider identifiers */
export type IntegrationProvider =
  | 'sage-intacct'
  | 'ledgersync'
  | 'divvy'
  | 'amex'
  | 'chase'

export interface ProviderInfo {
  id: IntegrationProvider
  name: string
  description: string
  category: 'erp' | 'bank' | 'card'
  icon?: string
}

export const INTEGRATION_PROVIDERS: Record<IntegrationProvider, ProviderInfo> = {
  'sage-intacct': {
    id: 'sage-intacct',
    name: 'Sage Intacct',
    description: 'GL, AP, and Facilities management',
    category: 'erp',
  },
  ledgersync: {
    id: 'ledgersync',
    name: 'Banking Data Provider',
    description: 'Bank account aggregation',
    category: 'bank',
  },
  divvy: {
    id: 'divvy',
    name: 'Divvy',
    description: 'Corporate card transactions',
    category: 'card',
  },
  amex: {
    id: 'amex',
    name: 'American Express',
    description: 'Corporate card transactions',
    category: 'card',
  },
  chase: {
    id: 'chase',
    name: 'Chase',
    description: 'Corporate card transactions',
    category: 'card',
  },
}

export const PROVIDER_CATEGORIES = {
  erp: 'ERP Systems',
  bank: 'Bank Accounts',
  card: 'Credit Cards',
} as const

export function getProvidersByCategory(category: 'erp' | 'bank' | 'card'): ProviderInfo[] {
  return Object.values(INTEGRATION_PROVIDERS).filter((p) => p.category === category)
}